
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiLayerStack as ObcPoiLayerStackElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-layer-stack/poi-layer-stack.js';
 
 
 

 
 export const ObcPoiLayerStack = createComponent({
   react: React,
   tagName: 'obc-poi-layer-stack',
   elementClass: ObcPoiLayerStackElement,
   events: {
     
   }
  });
 
 